
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'

@Component
export default class Empty extends Vue {
  // 空数据类型： 1、dd(暂无订单、暂无退单) 2、gwc(购物车空空如也) 3、ks(暂无客户) 4、sj(暂无数据、暂无商品、暂无公司) 5、ss(搜索内容为空) 6、xx(暂无消息)
  // 当type为sj时，text空文本可以有多种
  @Prop({ default: 'sj' }) type?: string
  @Prop({ default: '' }) text?: string
  @Prop({ default: 80 }) paddingTop?: number

  // 显示文本
  private showText = ''

  @Watch('type')
  @Watch('text')
  onTextChange () {
    this.getShowText()
  }

  mounted () {
    this.getShowText()
  }

  getShowText () {
    if (!this.text) {
      switch (this.type) {
        case 'dd':
          this.showText = '暂无订单'
          break
        case 'gwc':
          this.showText = '购物车空空如也'
          break;
        case 'ks':
          this.showText = '暂无客户'
          break
        case 'sj':
          this.showText = '暂无数据'
          break
        case 'ss':
          this.showText = '搜索内容为空'
          break
        case 'xx':
          this.showText = '暂无消息'
          break
      }
    } else {
      this.showText = this.text
    }
  }
}
